"use client";

import type { ReactNode } from "react";
import { selectLeadStatus, useAppSelector } from "@repo/web-store";

const BASE_CLASS =
  " max-h-[73px] fixed bottom-0 left-0 z-[99999] hidden min-h-[73px] w-screen pr-[73px] shadow-[-4px_-4px_6px_#00000014] md:flex";

interface OpenDematFloatBannerDesktopShellProps {
  children: ReactNode;
  isPdp?: boolean;
}

const OpenDematFloatBannerDesktopShell = ({
  children,
  isPdp = false,
}: OpenDematFloatBannerDesktopShellProps) => {
  const leadStatus = useAppSelector(selectLeadStatus);

  return (
    <div
      className={`${BASE_CLASS}${
        leadStatus === "ETB" && isPdp === true ? " md:hidden" : ""
      }`}
      aria-live="polite"
    >
      {children}
    </div>
  );
};

export default OpenDematFloatBannerDesktopShell;
 